import React, { useState } from 'react';
import { api } from '../api';
import { refreshCache } from '../store';

export default function TemplateForm({ template, categories, accounts, onSave, onCancel }) {
  const [type, setType] = useState(template?.type || 'expense');
  const [categoryId, setCategoryId] = useState(template?.categoryId || '');
  const [accountId, setAccountId] = useState(template?.accountId || '');
  const [amount, setAmount] = useState(template?.amount != null ? template.amount : '');
  const [description, setDescription] = useState(template?.description || '');
  const [localCats, setLocalCats] = useState(categories || []);
  const [newCatOpen, setNewCatOpen] = useState(false);
  const [newCatName, setNewCatName] = useState('');

  const handleCategoryChange = (e) => {
    const val = e.target.value;
    if (val === '__new__') {
      setNewCatOpen(true);
      setCategoryId('');
    } else {
      setCategoryId(val);
      setNewCatOpen(false);
    }
  };

  // Создать категорию прямо из формы шаблона и сразу выбрать её
  const addCategory = async () => {
    const name = newCatName.trim();
    if (!name) return;
    const created = await api.createCategory({ name, type });
    setLocalCats(prev => [...prev, created]);
    setCategoryId(String(created.id));
    setNewCatName('');
    setNewCatOpen(false);
    refreshCache();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      type,
      categoryId: parseInt(categoryId),
      accountId: accountId ? parseInt(accountId) : null,
      amount: amount === '' ? null : parseFloat(amount),
      description,
    });
  };

  const filteredCategories = localCats.filter(c => c.type === type);

  return (
    <form className="card" onSubmit={handleSubmit}>
      <h3>{template ? 'Редактировать шаблон' : 'Новый шаблон'}</h3>
      <div className="form-group">
        <label>Тип</label>
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="expense">Расход</option>
          <option value="income">Доход</option>
        </select>
      </div>
      <div className="form-group">
        <label>Категория</label>
        <select value={categoryId} onChange={handleCategoryChange} required>
          <option value="">Выберите категорию</option>
          {filteredCategories.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
          <option value="__new__">➕ Новая категория</option>
        </select>
        {newCatOpen && (
          <div style={{ display: 'flex', gap: '8px', marginTop: '6px' }}>
            <input
              type="text"
              placeholder="Название новой категории"
              value={newCatName}
              autoFocus
              onChange={(e) => setNewCatName(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addCategory(); } }}
            />
            <button type="button" onClick={addCategory}>OK</button>
          </div>
        )}
      </div>
      <div className="form-group">
        <label>Счёт (не обязательно)</label>
        <select value={accountId} onChange={(e) => setAccountId(e.target.value)}>
          <option value="">Не выбран</option>
          {(accounts || []).filter(a => !a.isDebt).map(a => (
            <option key={a.id} value={a.id}>{a.name}</option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label>Сумма (не обязательно)</label>
        <input type="number" inputMode="decimal" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="Например, 1500" />
      </div>
      <div className="form-group">
        <label>Описание</label>
        <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} />
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button type="submit">Сохранить</button>
        <button type="button" className="secondary" onClick={onCancel}>Отмена</button>
      </div>
    </form>
  );
}
